$(document).ready(function(){

  $("body").on('click','.pdp_spec_title',function () {				
    $(".pdp_spec_title").removeClass("active");				
    $(".pdp_spec_content").slideUp();		
    if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
    }
  });	
});

jQuery(document).ready(function ($) {
  
  if ($('#shopify-section-collection').length > 0){
    var reviewsCheck = setInterval(function(){
      
      var someFound = false;
      var limitCount = 0;
      $('.yotpo-sr-bottom-line-text').each(function(){
        if ($(this).text().trim() == "(0)" && $(this).closest('.reviewLine').is(':visible')){
          someFound = true;
          limitCount += 1;
          $(this).closest('.reviewLine').hide();
        }
      });
      if (someFound == true || limitCount == 20){
        clearInterval(reviewsCheck);
      }
      
    }, 100);

    var reviewsCheckTwo = setInterval(function(){
      
      var someFoundTwo = false;
      var limitCountTwo = 0;
      $('.yotpo-bottomline a').each(function(){
          someFoundTwo = true;
          limitCountTwo += 1;
          var starNumber = $(this).text().trim().split(' ')[0];
          $(this).text("(" + starNumber + ")")
      });
      if (someFoundTwo == true || limitCountTwo == 20){
        clearInterval(reviewsCheckTwo);
      }
      
    }, 100);
  }

  $('.pdpViewMore').on('click', function(){
    $(this).parent().hide();
    $('.pdpOverview__belowWrapper').slideDown();
  });

  $('[data-option="sm-rc-option1-selector"]').find('.swatch').each(function(){
    var color = $(this).attr('data-val');
    var imageSrc = $('[sm-rc-variant-selector]').find('[data-option-1="'+color+'"]').first().attr('data-image');
    $(this).find('img').attr('src', imageSrc);
  });

  $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();
      if($(this).attr('href').trim() == '#') return;
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top + -80
      }, 500);
  });

  $('.sm-qty--minus').on('click', function(){
    var currentQty = $('[sm-rc-quantity-selector]').val();
    if (currentQty > 1){
      $('[sm-rc-quantity-selector]').val(currentQty - 1).change();
    }
  });
  
  $('.sm-qty--plus').on('click', function(){
    var currentQty = $('[sm-rc-quantity-selector]').val();
    $('[sm-rc-quantity-selector]').val((currentQty * 1) + 1).change();
  });

  $('.mob_bar').on('click', function(){
    if ($('.mobMenu').is(':visible')){
      $('.mobMenu').fadeOut();
    }
    else{
      $('.mobMenu').fadeIn();
      $('#main-header').addClass('scrolling');
    }
  });

  $('.mobMenu__parent').on('click', function(){
    $(this).parent().find('.mobMenu__childContainer').fadeIn();
  });

  $('.mobMenu__childBack').on('click', function(){
    $(this).closest('.mobMenu__childContainer').fadeOut();
  });

  $('.mobMenu__child').on('click', function(){
    $(this).parent().find('.mobMenu__grandchildContainer').fadeIn();
  });

  $('.mobMenu__grandChildBack').on('click', function(){
    $(this).closest('.mobMenu__grandchildContainer').fadeOut();
  });

  var cartCount = CartJS.cart.item_count;
  var cartCountCheck = setInterval(function(){
    if (cartCount != CartJS.cart.item_count){
      $('.cart_count').text(CartJS.cart.item_count);

      var totalShip = parseInt($('.mini-cart').data('freeship'));
      var newCartTotal = CartJS.cart.items_subtotal_price;
      var awayShip = totalShip - newCartTotal;
      var shipPercent = newCartTotal / totalShip * 100;
    
      if (shipPercent >= 100) {
        $('.shipping-bar--progress').attr('style', 'width:100%');
        $('.mini-cart__ship').addClass('is-free');
      } else {
        if ($('.mini-cart__ship').hasClass('is-free')) {
          $('.mini-cart__ship').removeClass('is-free');
        }
    
        $('.free-count').text(formatter.format(awayShip / 100));
        console.log(shipPercent);
        $('.shipping-bar--progress').attr('style', 'width:'+shipPercent + '%');
      }

      if(CartJS.cart.item_count == 0){
        $('.mini-cart__footer .btn').hide();
      }
      else{
        $('.mini-cart__footer .btn').show();
      }
    }
    cartCount = CartJS.cart.item_count;
  }, 100);

  $('.pdp_size_var input').on('click', function(){
    var option = $(this).closest('.option__wrap').attr('data-option');
    var selected = $(this).attr('id');
    $('['+option+']').val(selected).change();
  });

  $('.pdp_size_var').find('input').first().click();

  $('nav a').on('click', function(){
    var href = $(this).attr('href');
    if (!$(this).parent().hasClass('has-children')){
      window.location.href = href;
    }
  });
});

var productCompareList = getProductCompareList();

function getProductCompareList() {
  return JSON.parse(localStorage.getItem('productCompareList')) || [];
}

function setProductCompareList() {
  localStorage.setItem('productCompareList', JSON.stringify(productCompareList));
}


function setCompare() {
  document.querySelectorAll('.product__compare-input').forEach(input => {
    const url = input.dataset.url;
    input.checked = productCompareList.indexOf(url) > -1;
  });  

  if($('.compare-popup').length) {
    if(productCompareList.length > 1) {
      $('.compare-popup').addClass('active');
    } else {
      $('.compare-popup').removeClass('active');
    }

    $('.compare-popup__header-text').find('span').text(`(${productCompareList.length})`);
    $('.compare-product__grid').empty();
    $('.compare-product__content').addClass('d-none');
    $('.compare-product__loading').removeClass('d-none');

    productCompareList.forEach(url => {
      fetch( `${url}?view=compare-card`)
      .then((response) => response.text())
      .then((markup) => {
        $('.compare-product__grid').append(markup);
        $('.compare-product__content').removeClass('d-none');
        $('.compare-product__loading').addClass('d-none');
      });
    });
  }
}
 
$(document).on('change', '.product__compare-input', function(e) {
  const isCheck = this.checked;
  const productUrl = $(this).data('url');
  if(isCheck) {
    if(productCompareList.indexOf(productUrl) == -1) {
      productCompareList.push(productUrl);
      setProductCompareList();
      if($('.suggested-items').length) {
        addCompareItem(productUrl);
      }
    }
  } else {
    if(productCompareList.indexOf(productUrl) > -1) {
      productCompareList = productCompareList.filter((url) => url != productUrl);
      setProductCompareList();
      $(`.page-compare-product__remove[data-url="${productUrl}"]`)?.click();
    }
  }
  setCompare();
});

$(document).on('click', '.compare-product__remove', function(e) {
  const productUrl = $(this).data('url');
  productCompareList = productCompareList.filter((url) => url != productUrl);
  setProductCompareList();
  setCompare();
});

$(document).on('click', '.clear__compare-products', function(e){
  e.preventDefault();
  productCompareList = [];
  setProductCompareList();
  setCompare();
});

function addCompareItem (url) {
  fetch( `${url}?view=compare-item`)
  .then((response) => response.text())
  .then((markup) => {
    const container = document.createElement('div');
    $(container).append(markup);
    const details = $(container).find('.product__details').find('.product-info-item');
    $('.page-compare-products__grid').append($(container).find('.product'));
    for(var i=0;i<10;i++) {
      const firstTr = $('.page-compare-products__detail-table table').find('tr').eq(2 * i);
      const secondTr = $('.page-compare-products__detail-table table').find('tr').eq(2 * i + 1);
      firstTr.append(details.eq(i).find('th').length > 0 ? details.eq(i).find('th') : $('<th></th>'));
      secondTr.append(details.eq(i).find('td').length > 0 ? details.eq(i).find('td') : $('<td></td>'));
    }

    for(var i=0<i<20;i++;) {
      const tr = $('.page-compare-products__detail-table table').find('tr')[i];
      var isHide = true;
      if(!tr) return;
      tr.querySelectorAll('th, td').forEach(el => {
        if(el.textContent) isHide = false;
      });
      if(isHide) tr.classList.add('hidden');
      else tr.classList.remove('hidden');
    }
  });
}

$(document).on('click', '.page-compare-product__remove', function(e){
  const productUrl = $(this).data('url');
  const index = $(this).closest('.product').index();
  console.log(index);
  $(this).closest('.product').remove();
  $('.page-compare-products__detail-table').find('tr').each(function(){
    $(this).find('th').eq(index).remove();
    $(this).find('td').eq(index).remove();
  });
  productCompareList = productCompareList.filter((url) => url != productUrl);
  setProductCompareList();
  $(`.product__compare-input[data-url="${productUrl}"]`)?.prop('checked', false);
});

$(document).on('click', '.page-compare-products__detail-expand', function(e){
  $('.page-compare-products__detail-table').addClass('expand');
  $(this).remove();
});

$(document).on('change', '#page-compare-products__highlight-input', function(){
  const isCheck = this.checked;
  if(isCheck) $('.page-compare-products__detail-table').addClass('highlight');
  else $('.page-compare-products__detail-table').removeClass('highlight');
});

$(document).ready(function() {
  setCompare();
  if($('.page-compare-products__grid').length) {
    productCompareList.forEach(url => {
      addCompareItem(url);
    });

    $(document).scroll(function(e){
      const scrollTop = $(document).scrollTop();
      const detailBottomPosition = $('.page-compare-products__detail').offset().top;
      if(scrollTop > detailBottomPosition - 300) {
        $('.page-compare-products__grid-content').addClass('fixed');
      } else {
        $('.page-compare-products__grid-content').removeClass('fixed');
      }
   });

   $('.page-compare-products__grid').scroll(function(){
    const scroLeft = $(this).scrollLeft();
    $('.page-compare-products__detail-table').scrollLeft(scroLeft);
   });

   $('.page-compare-products__detail-table').scroll(function(){
    const scroLeft = $(this).scrollLeft();
    $('.page-compare-products__grid').scrollLeft(scroLeft);
   });
  }

  if(document.querySelector('.breadcrumb-link') && localStorage.getItem("previouslyCollectionLink")) {
    document.querySelector('.breadcrumb-link').setAttribute("href", localStorage.getItem("previouslyCollectionLink"));
  }
});

$(document).on('click', '#compare-products__print', function(e){
  e.preventDefault();
  var pageTitle = 'Compare Products',
      stylesheet = '//maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css',
      win = window.open('', 'Print', 'width=500,height=300');
  win.document.write('<html><head><title>' + pageTitle + '</title>' +
      '<link rel="stylesheet" href="' + stylesheet + '">' +
      '</head><body>' + $('.page-compare-products__detail-table')[0].outerHTML + '</body></html>');
  win.document.close();
  win.print();
  win.close();
  return false;
});


$(document).on("click", "#compare-products__save", function () {
  const source = document.querySelector('.page-compare-products__detail-table').querySelector('table').innerHTML;
  const table = document.getElementById('pdf-table');
  table.innerHTML = source;
  setTimeout(() => {
    html2canvas(table, {
      onrendered: function (canvas) {
          var data = canvas.toDataURL();
          var docDefinition = {
              content: [{
                  image: data,
                  width: 500
              }]
          };
          pdfMake.createPdf(docDefinition).download("compare-products.pdf");
          setTimeout(() => {
            table.innerHTML = '';
          }, 100);
      }
    });
  }, 100);
});

$(document).on('click', ".compare-product__link", function(e) {
  localStorage.setItem("previouslyCollectionLink", location.href);
});